import { ImportProvidersSource } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { MapSitesState } from '../store/states/map-sites.state';
import { environment } from '../../environments/environment';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { MapTagsState } from '../store/states/map-tags.state';
import { MapBbxState } from '../store/states/map-bbx.state';
import { MapTabsState } from '../store/states/map-tabs.state';

const devStoreConfig: ImportProvidersSource[] = [];
if (!environment.production) {
  devStoreConfig.push(NgxsReduxDevtoolsPluginModule.forRoot());
  devStoreConfig.push(
    NgxsLoggerPluginModule.forRoot({ collapsed: true, disabled: true }),
  );
}

export const storeProviders: ImportProvidersSource[] = [
  NgxsModule.forRoot([MapSitesState, MapTagsState, MapBbxState, MapTabsState], {
    developmentMode: !environment.production,
  }),
  ...devStoreConfig,
  NgxsStoragePluginModule.forRoot({
    keys: [MapSitesState],
  }),
];
